import { parseHTML } from '../../services/parseHTML';
import { Storyblok, StoryblokSection } from '../../storyblok';
import React from 'react';
import {
    IntroBackgroundImage,
    IntroContent,
    IntroText,
    IntroWrapper,
} from './styles';

export const Intro = ({
    sectionData,
}: StoryblokSection<Storyblok.Component.Intro>) => {
    const {
        background_image,
        text,
        content,
        component,
        objectFit,
        objectPosition,
    } = sectionData;

    return (
        <IntroWrapper className="Intro" data-block={component}>
            {background_image && (
                <IntroBackgroundImage
                    image={background_image.filename}
                    style={{ objectFit, objectPosition }}
                />
            )}
            {content && (
                <IntroContent>{parseHTML(content, 'markdown')}</IntroContent>
            )}
            <IntroText>{text}</IntroText>
        </IntroWrapper>
    );
};
